import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TraslateService {

  constructor(private http: HttpClient) {
    this.getateliers()
    this.getTypeVehicule()
    this.getRevendeur()

   }
  obs: Observable<Object>;
  obs1: Observable<Object>;
  obs2: Observable<Object>;
  obs3: Observable<Object>;

  maptoAtelier(response ,series1:any[] ):void{

    response.forEach(element => {

      series1.push([Number(element?.x),
        Number(element?.y),
          Number(element?.z),
          element?.name
      ]);
    });
  }



  maptoAtelier2(response ,series2:any[] , series3:any[] ,series4:any[] ):void{

    response.forEach(element => {

      if (element.avg_interval <20 ) {
        var style  = "verticalLines"
        var colors = '#F44336'
      } else if (element.avg_interval <90 ) {
        var style  = "squares"
        var colors = '#E91E63'
      }else{
        var style  = "horizontalLines"
        var colors = '#9C27B0'
      }



      series2.push(Number(element?.units)


      );

      series3.push(
        style


     );


     series4.push(
      colors);
    });
  }



  getateliers(): void{
    this.obs = this.http.get('https://my-json-server.typicode.com/issam-sudo/Gemography_Front-end_Coding_Challenge/xScoreGit2');
    //this.obs.subscribe((response)=>this.maptoAtelier(response));
  }




  getTypeVehicule(): void{
    this.obs1 = this.http.get(environment.apiUrl+'/unit/types');
    //this.obs.subscribe((response)=>this.maptoAtelier(response));
  }

  getRevendeur(): void{
    this.obs2 = this.http.get(environment.apiUrl+'/resellers');
    //this.obs.subscribe((response)=>this.maptoAtelier(response));
  }


  getVehicules(page , filtre? ){
    if(filtre) {
      return this.http.get(environment.apiUrl+'/unit/list'+'?page='+page+'&device_id='+filtre.device_id+'&unit_type='+filtre.unit_type+'&calibration='+filtre.calibration+'&company_id='+filtre.company_id)

    } else {
      return this.http.get(environment.apiUrl+'/unit/list'+'?page='+page)

    }

  }


  getCompanies() {
    return this.http.get(environment.apiUrl+'/companies')
  }


  urlPathQuote   = new BehaviorSubject(null);
  currentdataQuote = this.urlPathQuote.asObservable();

  urlPathlogQuote   = new BehaviorSubject(null);
  currentdatalogQuote = this.urlPathlogQuote.asObservable();

  urlfavPathQuote   = new BehaviorSubject(null);
  currentfavdataQuote = this.urlfavPathQuote.asObservable();

  UserAlarmEventQuote   = new BehaviorSubject(null);
  UserAlarmEventdataQuote = this.UserAlarmEventQuote.asObservable();

  UserAlarmAccQuote   = new BehaviorSubject(null);
  UserAlarmAccdataQuote = this.UserAlarmAccQuote.asObservable();

  urlcompanyQuote   = new BehaviorSubject(null);
  currentcompanyQuote = this.urlcompanyQuote.asObservable();

  urlcompanyuserQuote   = new BehaviorSubject(null);
  currentcompanyuserQuote = this.urlcompanyuserQuote.asObservable();

  urluserQuote = new BehaviorSubject(null);
  currentUserQuote = this.urluserQuote.asObservable();

  reportfavQuote = new BehaviorSubject("null");
  reportfavdataQuote = this.reportfavQuote.asObservable();


  reportplanQuote = new BehaviorSubject(null);
  reportplandataQuote = this.reportplanQuote.asObservable();


  urlPath   = new BehaviorSubject(null);
  currentdata = this.urlPath.asObservable();
  gogo ='fr';

   message = new BehaviorSubject("");
  sharedMessage = this.message.asObservable();

  UnitID   = new BehaviorSubject(null);
  currentUnitID = this.UnitID.asObservable();

  urlScorechrt   = new BehaviorSubject(null);
  currentdataScore = this.urlScorechrt.asObservable();

  urlCalibration  = new BehaviorSubject("null");
  currentdataCalibration = this.urlCalibration.asObservable();

  urlCommunication  = new BehaviorSubject("null");
  currentdataCommunication = this.urlCommunication.asObservable();

  position   = new BehaviorSubject(null);
  positionarray = this.position.asObservable();

  contactSelected   = new BehaviorSubject("null");
  contactSelectedarray = this.contactSelected.asObservable();

  crashCoordonnées   = new BehaviorSubject("null");
  crashdata = this.crashCoordonnées.asObservable();

  UrlPdf   = new BehaviorSubject("null");
  UrlPdfGenerate = this.UrlPdf.asObservable();


  nextMessage(message: string) {
    this.message.next(message)
  }

}
